import { EllipsisOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { ButtonProps } from "antd/lib/button";
import React from "react";
export type IButton = ButtonProps;

const EllipseIcon: React.FC<any> = (props) => {
    const { isButton = false, size } = props;
    // const clickAction = props?.onClick;
    let buttonSize = "default";

    if (size === "sm") {
        buttonSize = "small";
    } else if (size === "lg") {
        buttonSize = "large";
    }

    // const handleClick = _.debounce(clickAction, 2000);

    return isButton ? (
        <Button
            size={buttonSize}
            icon={<EllipsisOutlined rotate={90} />}
            shape="circle"
            type="primary"
            {...props}
        />
    ) : (
        <EllipsisOutlined rotate={90} {...props} onClick={props?.onClick} />
    );
};

export default EllipseIcon;
